import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { graph } from '@adc/constants'
import { formatTitleCase } from '../../../utils/formatters'
import { Label, Dropdown } from 'semantic-ui-react'
import { ColorHash } from '../../../utils' // core index

const { enums } = graph

/**
 * convert Graph Enums to dropdown options
 * example: "EXTERIOR_FRONT" ==> "{ text: Exterior Front", value: "EXTERIOR_FRONT}"
 *
 * DO NOT USE for exception:  "THIRD_PARTY"  =X=> "{ text: "3rd Party", value: "THIRD_PARTY}"
 */
export const convertGraphEnumToOptions = graphEnum =>
  Object.values(graphEnum).map(val => ({
    text: formatTitleCase(val),
    value: val,
  }))

const photoTagOptions = [
  { text: 'No Tag', value: '' },
  ...convertGraphEnumToOptions(enums.PropertyPhotoTag),
]

const colorHash = new ColorHash()

const TagDropdown = ({
  tag = '',
  elmId = 'tag_dropdown',
  size = 'mini',
  onTagChange = () => {},
  ...props
}) => {
  const [label, setLabel] = useState(tag)
  const { disabled } = props
  const trigger = (
    <Label
      size={size}
      style={{
        backgroundColor: label && !disabled ? colorHash.hex(label) : '#5c676e',
        color: '#fff',
        fontWeight: '700',
      }}
      content={formatTitleCase(label) || 'Click to Tag'}
      tag
    />
  )

  const onChange = useCallback(
    (e, data) => {
      onTagChange(data.value)
      setLabel(data.value)
    },
    [label]
  )

  return (
    <Dropdown
      trigger={trigger}
      icon={null}
      data-elm-id={elmId}
      onChange={onChange}
      value={label}
      options={photoTagOptions}
      disabled={disabled}
      {...props}
    />
  )
}

TagDropdown.propTypes = {
  tag: PropTypes.string,
  size: PropTypes.oneOf([
    'mini',
    'tiny',
    'small',
    'medium',
    'large',
    'big',
    'huge',
    'massive',
  ]),
  elmId: PropTypes.string,
  ...Dropdown.PropTypes,
}

export default TagDropdown
